export const redirect = (url: string): void => {
  window.location.href = url;
};
